import React from "react";
import { Github, Twitter, Linkedin, Mail } from "lucide-react";
import logo from "../assets/logo.png";

const Footer = () => {
    const currentYear = new Date().getFullYear();

    const footerSections = [
        {
            title: "Product",
            links: [
                { name: "Features", href: "#features" },
                { name: "Integrations", href: "#demo" },
                { name: "Pricing", href: "#pricing" },
                { name: "FAQ", href: "#faq" },
            ],
        },
        {
            title: "Company",
            links: [
                { name: "About Us", href: "#about" },
                { name: "Blog", href: "#blog" },
                { name: "Careers", href: "#careers" },
                {
                    name: "Contact",
                    href: "https://docs.google.com/forms/d/e/1FAIpQLSeSw1JKGrFydRwtW0OmaMVGNQqHwvw1CPLDYGPF-qY80jK_cQ/viewform?usp=publish-editor",
                },
            ],
        },
        {
            title: "Resources",
            links: [
                { name: "Documentation", href: "#docs" },
                { name: "API Reference", href: "#api" },
                { name: "Help Center", href: "#help" },
                { name: "Status", href: "#status" },
            ],
        },
        {
            title: "Legal",
            links: [
                { name: "Privacy Policy", href: "#privacy" },
                { name: "Terms of Service", href: "#terms" },
                { name: "Security", href: "#security" },
                { name: "Compliance", href: "#compliance" },
            ],
        },
    ];

    const socialLinks = [
        { icon: Twitter, href: "#twitter", label: "Twitter" },
        { icon: Linkedin, href: "#linkedin", label: "LinkedIn" },
        { icon: Github, href: "#github", label: "GitHub" },
        { icon: Mail, href: "#email", label: "Email" },
    ];

    return (
        <footer className="bg-slate-900 text-slate-300">
            <div className="max-w-7xl mx-auto px-6 py-16">
                {/* Main footer content */}
                <div className="grid md:grid-cols-2 lg:grid-cols-6 gap-12 mb-12">
                    {/* Brand section */}
                    <div className="lg:col-span-2">
                        <div className="flex items-center gap-2 mb-4">
                            <img
                                src={logo}
                                alt="Nucleus"
                                className="w-10 h-10"
                            />
                            <span className="text-2xl font-bold text-white">
                                Nucleus
                            </span>
                        </div>
                        <p className="text-slate-400 leading-relaxed mb-6 max-w-xs">
                            Your AI Chief of Staff for engineering operations.
                            Stop manual reporting, start making data-driven
                            decisions.
                        </p>
                        <div className="flex gap-4">
                            {socialLinks.map((social) => {
                                const Icon = social.icon;
                                return (
                                    <a
                                        key={social.label}
                                        href={social.href}
                                        aria-label={social.label}
                                        className="w-10 h-10 bg-slate-800 hover:bg-slate-700 rounded-lg flex items-center justify-center transition-colors duration-300 group"
                                    >
                                        <Icon className="w-5 h-5 text-slate-400 group-hover:text-white transition-colors duration-300" />
                                    </a>
                                );
                            })}
                        </div>
                    </div>

                    {/* Footer links */}
                    {footerSections.map((section) => (
                        <div key={section.title}>
                            <h3 className="text-white font-bold mb-4">
                                {section.title}
                            </h3>
                            <ul className="space-y-3">
                                {section.links.map((link) => (
                                    <li key={link.name}>
                                        <a
                                            href={link.href}
                                            className="text-slate-400 hover:text-white transition-colors duration-300"
                                        >
                                            {link.name}
                                        </a>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    ))}
                </div>

                {/* Bottom bar */}
                <div className="pt-8 border-t border-slate-800">
                    <div className="flex flex-col md:flex-row justify-between items-center gap-4">
                        <p className="text-sm text-slate-500">
                            © {currentYear} Nucleus. All rights reserved.
                        </p>
                        <div className="flex gap-6 text-sm">
                            <span className="text-slate-500">
                                SOC 2 Type II Certified
                            </span>
                            <span className="text-slate-500">•</span>
                            <span className="text-slate-500">
                                GDPR Compliant
                            </span>
                            <span className="text-slate-500">•</span>
                            <span className="text-slate-500">99.9% Uptime</span>
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
